// eslint-disable-next-line no-restricted-imports
import {Component, PanelLifecycleContext} from 'panel';

import {Subscribable} from 'common/types/context/subscribable';
import {
  activatePersistedZendeskChat,
  activateZendeskChat,
  ChatDepartment,
  hideZendeskWidget,
} from 'common/report/external-widgets/zendesk';
import {UserIdentity} from 'common/report/util/user-identity-from-cookie';

type State = {
  showSupportWidget: boolean;
  isSupportWidgetMaximized: boolean;
};

export class CustomerSupportManager implements PanelLifecycleContext, Subscribable {
  private connectedComponents: Set<Component<any>> = new Set();
  private subscriptions: Array<() => void> = [];

  public state = {
    showSupportWidget: false,
    isSupportWidgetMaximized: false,
  };

  updateState(stateUpdate: Partial<State>) {
    this.state = Object.assign({}, this.state, stateUpdate);
    this.updateComponents();
  }

  hideAllWidgets() {
    this.updateState({showSupportWidget: false});
    hideZendeskWidget();
  }

  openZendeskChat({currentUser}: {currentUser: UserIdentity}) {
    this.hideAllWidgets();
    activateZendeskChat(ChatDepartment.Support, currentUser.name, currentUser.email);
  }

  openPersistedZendeskChat({currentUser}: {currentUser: UserIdentity}) {
    activatePersistedZendeskChat(ChatDepartment.Support, currentUser.name, currentUser.email);
  }

  openContactSupport({isSupportWidgetMaximized}: {isSupportWidgetMaximized?: boolean} = {}) {
    this.hideAllWidgets();
    this.updateState({
      showSupportWidget: true,
      ...(typeof isSupportWidgetMaximized === `boolean` ? {isSupportWidgetMaximized} : {}),
    });
  }

  subscribe(callback: () => void): this {
    this.subscriptions.push(callback);
    return this;
  }

  unsubscribe(callback: () => void): this {
    this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
    return this;
  }

  bindToComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.add(component);
  }

  unbindFromComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.delete(component);
  }

  updateComponents() {
    for (const component of this.connectedComponents) {
      component.update();
    }
    for (const subscription of this.subscriptions) {
      subscription();
    }
  }
}
